import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {RecieptVouchers} from './reciept_vouchers';

@Injectable()
export class RecieptVouchersService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('reciept_vouchers?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('reciept_vouchers/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('reciept_vouchers/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('reciept_vouchers/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('reciept_vouchers/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(invoice: RecieptVouchers) {
        return this.http.post('reciept_vouchers', invoice).map((response: Response) => response.json());
    }

    update(invoice: RecieptVouchers) {
        return this.http.put('reciept_vouchers/' + invoice.id, invoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('reciept_vouchers/' + _id).map((response: Response) => response.json());;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/reciept_vouchers/reciept_vouchers.service.ts